<template>
    <div v-for="(domaine, index) in domaines" :key="domaine.id" :id="`${domaine.url}`">
        <section class="expertises">
            <div class="add-padding ">
                <h2 class="sous-section ">
                    <span class="span-background-blue">
                        {{ domaine.nomDomaine }}
                    </span>
                </h2>
                <div class="row pt-80">
                    <div class="wrap" v-if="isLoading">
                        <div class="spinner-wrap">
                            <div class="spinner">
                                <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                            </div>
                        </div>
                    </div>
                    <div v-for="(item, index) in equipesParCategorie[domaine.pIdCat]" :key="item.idA" class="col-md-4">
                        <div class="item mb-4">
                            <div class="card-block">
                                <img :src='imageUrl(item.idA, item.siteIdA, item.pictureThumbA)' :alt="item.titleSubA"
                                    v-if="item.pictureThumbA.length > 0">
                                <img src='/images/icon/person_icon.png' :alt="item.titleSubA" v-else>
                                <div class="bodyCard hover tran3s d-flex flex-column">
                                    <span class="title">{{ item.titleA }}</span>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <p class="subtitle">{{ item.titleSubA }}</p>
                                        <a :href="`${item.describeA}`" target="_blank" v-if="item.describeA.length > 0">
                                            <div class="text-end linkedInClass">
                                                <i>
                                                    <svg width="22" height="24" viewBox="0 0 22 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M20.0714 1.5C20.8682 1.5 21.5714 2.20312 21.5714 3.04688V21C21.5714 21.8438 20.8682 22.5 20.0714 22.5H2.02448C1.2276 22.5 0.57135 21.8438 0.57135 21V3.04688C0.57135 2.20312 1.2276 1.5 2.02448 1.5H20.0714ZM6.89948 19.5V9.51562H3.80573V19.5H6.89948ZM5.3526 8.10938C6.33698 8.10938 7.13385 7.3125 7.13385 6.32812C7.13385 5.34375 6.33698 4.5 5.3526 4.5C4.32135 4.5 3.52448 5.34375 3.52448 6.32812C3.52448 7.3125 4.32135 8.10938 5.3526 8.10938ZM18.5714 19.5V14.0156C18.5714 11.3438 17.962 9.23438 14.8214 9.23438C13.3214 9.23438 12.2901 10.0781 11.8682 10.875H11.8214V9.51562H8.86823V19.5H11.962V14.5781C11.962 13.2656 12.1964 12 13.837 12C15.4307 12 15.4307 13.5 15.4307 14.625V19.5H18.5714Z"
                                                            fill="#318EC7" />
                                                    </svg>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script setup>
import { ref, onMounted } from "vue";
import axios from 'axios';

const isLoading = ref([]);

const domaines = ref([
    {
        id: 1,
        url: 'bilan-competences',
        nomDomaine: 'Bilan de compétences',
        pIdCat: 73
    }
])


const equipesParCategorie = ref({});

onMounted(async () => {
    isLoading.value = true;
    try {
        chargerEquipes();

        isLoading.value = false;
    } catch (error) {
        console.error('Erreur lors du chargement des données :', error);
        isLoading.value = false;
    }
});
async function chargerEquipes() {
    for (const domaine of domaines.value) {
        const response = await axios({
            method: 'post',
            url: 'https://ws2-gbbu02.graphibox.eu/EpArticles.ws',
            data: {
                pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872',
                pFct: 'GetArticles',
                pIdCat: domaine.pIdCat,
            },
        });

        const updatedData = response.data.map(item => {
            const urlMatch = item.describeA.match(/https?:\/\/[^\s]+</);
            if (urlMatch) {
                const urlMatch1 = urlMatch[0].split('<');
                if (urlMatch1) {
                    item.describeA = urlMatch1[0];
                } else {
                    item.describeA = urlMatch[0];
                }
            } else {
                item.describeA = "";
            }
            return item;
        });
        equipesParCategorie.value[domaine.pIdCat] = updatedData;
    }
}


</script>

<style scoped>
.linkedInClass {
    min-width: 50px;
    min-height: 50px;
    padding: 15px;
}

.desktop {
    display: block;
}

a .text-end,
.text-end,
.text-end i {
    z-index: 9999;
}

.fixed-menu-team {
    position: fixed;
    margin-top: -50px !important;
    z-index: 2;
}

.btn-item {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    gap: 20px;
    align-self: stretch;
    flex-wrap: wrap;
}

.pole {
    border: var(--tertiaire, #318EC7);
    border-radius: 50px;
    background: var(--tertiaire, #318EC7);
    color: var(--zinc-0, #FFF);
    text-align: center;
    padding: 10px 20px;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.8px;
}

.pole:hover {
    background-color: transparent;
    border: 1px solid #000;
    color: var(--primaire, #000);
}

.titre-section {
    color: var(--accent, #25233E);
    text-align: center;
    font-family: Nunito;
    font-size: 3.125rem;
    /*50 px */
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.sous-section {
    margin: 2rem 0;
    font-family: Inter;
    font-size: 3.4375rem;
    font-style: normal;
    font-weight: 600;
    color: var(--accent, #25233E);
    text-align: center;
    font-size: 30px;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}


.section-padding {
    margin-top: -20px;
}


.add-padding {
    padding: 0 210px;
    padding-top: 5px !important;
}


.item {
    border-radius: 0.5625rem;
    background: #FFF;
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.08);
}

.card-block img {
    border-radius: 0.5625rem 0.5625rem 0 0;
}

.title {
    color: #318EC7;
    font-family: Inter;
    font-size: 29px;
    font-style: normal;
    font-weight: 500;
}

.subtitle {
    line-height: 144%;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
}

.bodyCard {
    padding: 1.875rem 1.5625rem;
    row-gap: 2rem;
    height: 170px;
}

.bloctitleText {
    font-family: Inter;
    font-size: 1.3125rem;
    font-style: normal;
    font-weight: 600;
}

.scroll::before {
    content: "";
    display: block;
    height: 280px;
    margin-top: -280px;
    visibility: hidden;
    z-index: -1;
}


@media only screen and (min-width: 300px) and (max-width: 767px) {
    .desktop {
        display: none;
    }

    .first-div-team {
        padding-top: 0px;
    }

    .scroll::before {
        margin-top: -402px;
    }

    .pt-80 {
        padding-top: 0px;
    }

    .add-padding {
        padding: 0px 10px;
        padding-bottom: 3rem;
    }

    h4 {
        font-size: 15px;
    }

    .btn-item {
        gap: 10px;
    }

    .d-flex.justify-content-center {
        max-width: 80%;
        margin: auto;
        text-align: center;
    }

    .pole {
        font-size: 14px;
        padding: 5px 15px;
    }

    .sous-section {
        font-size: 15px;
    }

    .item {
        width: 80%;
        margin: 0px 13%;
    }

    .title {
        font-size: 15px !important;
    }

    .subtitle {
        font-size: 14px !important;
        ;

    }

    .linkedInClass {
        min-width: 10px;
        min-height: 10px;
        padding: 10px;
    }
}

@media (width: 768px) {
    .desktop {
        display: none;
    }

    .first-div-team {
        padding-top: 0px;
    }

    .scroll::before {
        margin-top: -402px;
    }

    .pt-80 {
        padding-top: 0px;
    }

    .add-padding {
        padding: 0px 10px;
        padding-bottom: 0rem;
    }

    h4 {
        font-size: 15px;
    }

    .btn-item {
        gap: 10px;
    }

    .d-flex.justify-content-center {
        max-width: 80%;
        margin: auto;
        text-align: center;
    }

    .pole {
        font-size: 13px;
        padding: 5px 15px;
    }

    .sous-section {
        font-size: 20px;
    }

    .item {
        width: 90%;
        margin: 0px 10px;
    }

    .title {
        font-size: 17px !important;
    }

    .subtitle {
        font-size: 15px !important;
        ;

    }

    .linkedInClass {
        min-width: 10px;
        min-height: 10px;
        padding: 10px;
    }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {
    .desktop {
        display: none;
    }

    .first-div-team {
        padding-top: 0px;
    }

    .scroll::before {
        margin-top: -402px;
    }

    .pt-80 {
        padding-top: 0px;
    }

    .add-padding {
        padding: 0px 10px;
        padding-bottom: 3rem;
    }

    h4 {
        font-size: 15px;
    }

    .btn-item {
        gap: 10px;
    }

    .d-flex.justify-content-center {
        max-width: 80%;
        margin: auto;
        text-align: center;
    }

    .pole {
        font-size: 13px;
        padding: 5px 15px;
    }

    .sous-section {
        font-size: 20px;
    }

    .item {
        width: 90%;
        margin: 0px 10px;
    }

    .title {
        font-size: 17px !important;
    }

    .subtitle {
        font-size: 15px !important;
        ;

    }

    .linkedInClass {
        min-width: 10px;
        min-height: 10px;
        padding: 10px;
    }
}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .first-div-team {
        padding-top: 240px;
    }

    .add-padding {
        padding: 0px 210px;
        padding-bottom: 0rem !important;
    }

    h4 {
        font-size: 17px;
    }

    .d-flex.justify-content-center {
        max-width: 100%;
        margin: auto;
        text-align: center;
    }

    .btn-item {
        gap: 10px;
    }

    .pole {
        font-size: 15px;
        padding: 8px 18px;
    }

    .sous-section {
        font-size: 25px;
    }



    .item {
        width: 100%;
        margin: 0px 10px;
    }

    .title {
        font-size: 17px !important;
    }

    .subtitle {
        font-size: 15px !important;
        ;

    }

    .linkedInClass {
        min-width: 10px;
        min-height: 10px;
        padding: 10px;
    }
}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {
    .add-padding {
        padding: 0px 210px;
        padding-bottom: 0.1rem !important;
    }

    h4 {
        font-size: 17px;
    }

    .d-flex.justify-content-center {
        max-width: 100%;
        margin: auto;
        text-align: center;
    }

    .btn-item {
        gap: 10px;
    }

    .pole {
        font-size: 15px;
        padding: 8px 18px;
    }

    .sous-section {
        font-size: 25px;
    }



    .item {
        width: 100%;
        margin: 0px 10px;
    }

    .title {
        font-size: 17px !important;
    }

    .subtitle {
        font-size: 15px !important;
    }

    .linkedInClass {
        min-width: 10px;
        min-height: 10px;
        padding: 10px;
    }
}
</style>